import s from "./style.module.css";
import type { designDisciplines } from "@/data/design-disciplines";
import type { PaddingSize } from "../content-section/index.marko";
export interface Input {
    paddingBlock?: (PaddingSize | null)[];
    links: typeof designDisciplines;
}

<content-section paddingBlock=input.paddingBlock>
    <ul class=s.list>
        <for|discipline| of=input.links>
            <li>
                <a
                    href=`/about#${discipline.id}`
                    class=s.link
                    data-color=discipline.color>
                    <span>
                        <div class=s.text>
                            <h3>${discipline.title}</h3>
                            <p>${discipline.tagline}</p>
                        </div>
                        <icon-button
                            class=s.iconButton
                            tabindex=-1
                            aria-hidden="true">
                            <icon-chevron-right-20/>
                        </icon-button>
                    </span>
                </a>
            </li>
        </for>
    </ul>
</content-section>
